<template>
  <v-card class="elevation-0">
    <v-card-text>
      <v-form v-model="valid" lazy-validation>
        <v-text-field
          prepend-icon="mdi-account"
          label="Username"
          name="username"
          id="username"
          type="email"
          required
          :rules="rules.email"
          validate-on-blur
          v-model="email"
        ></v-text-field>
        <v-text-field
          prepend-icon="mdi-lock"
          label="Password"
          name="password"
          id="password"
          :append-icon="visible ? 'mdi-eye' : 'mdi-eye-off'"
          :type="visible ? 'text' : 'password'"
          @click:append="visible = !visible"
          required
          :rules="rules.password"
          validate-on-blur
          v-model="password"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="!valid" @click="log_in">Sign in</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import allrules from "@/resources/rules";

export default {
  data() {
    return {
      email: "",
      password: "",
      visible: false,
      valid: false,
      loading: false,
    };
  },

  computed: {
    rules() {
      return allrules
    }
  },

  methods: {
    clear() {
      this.email = ''
      this.password = ''
      this.visible = false
      this.valid = false
    },

    log_in() {
      let user_creds = {
        username: this.email,
        password: this.password
      };

      this.loading = true;
      this.$store
        .dispatch("user/auth/login", user_creds)
        .then(response => this.$router.push("/users"))
        .finally(() => {
          this.loading = false
          this.clear()
        });
    }
  }
};
</script>
